<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <d-row no-gutters class="page-header py-4">
      <d-col col sm="4" class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle">Painel de controle</span>
        <h3 class="page-title">Visão Global</h3>
      </d-col>
    </d-row>

    <!-- Small Stats Blocks -->
    <!-- <d-row>
        <d-col lg v-for="(stats, idx) in smallStats" :key="idx" class="mb-4">
          <small-stats :id="`small-stats-${idx}`" variation="1" :chart-data="stats.datasets" :label="stats.label" :value="stats.value" :percentage="stats.percentage" :increase="stats.increase" :decrease="stats.decrease" />
        </d-col>
    </d-row> -->

    <d-row>
      <!-- Users Overview -->
      <d-col lg="8" md="6" sm="12" class="mb-4">
        <!-- <bo-users-overview /> -->
      </d-col>

      <!-- Users by Device (lite) -->
      <d-col lg="4" md="6" sm="12" class="mb-4">
        <!-- <bo-users-by-device /> -->
      </d-col>
    </d-row>

    <d-row>

      <!-- Last Registers -->
      <!-- <d-col lg="6" md="12" sm="12" class="mb-4">
        <last-Registers />
      </d-col> -->

      <!-- Registers list by status -->
      <!-- <d-col lg="6" md="12" sm="12" class="mb-4">
        <status-Registers />
      </d-col> -->
    </d-row>
  </d-container>
</template>

<script>
import SmallStats from '_common/components/dashboard/SmallStats.vue';
import LastRegisters from '_common/components/dashboard/LastRegisters.vue';
import StatusRegisters from '_common/components/dashboard/StatusRegisters.vue';

export default {
  components: {
    SmallStats,
    LastRegisters,
    StatusRegisters,
  },
  data() {
    return {
      smallStats: null,
    };
  },
  methods: {
  },
  computed: {
  },
  mounted() {
  },
};
</script>

